import GetApi from '../../../common/api/get'
import PostApi from '../../../common/api/post'
import ErrorHelper from '../../../common/helpers/error_helper'

export const bedTypeOptions = () => {
  return dispatch => {
    const getApi = new GetApi()
    return getApi.execute(routeUrlHelper.classificationsBedTypesPath(), "").then(
      (res) => {
        dispatch(getBedTypeOptions(res))
      },
      (res) => { dispatch(error("main", res)) }
    )
  }
}

const getBedTypeOptions = (res) => {
  return {
    type: 'BED_TYPE_OPTIONS',
    result: res.body
  }
}

const setState = (params) => {
  return {
    type: 'SET_STATE_ROOM_GROUP',
    params: params
  }
}

export const error = (element, res = "") => {
  return {
    type: 'BED_TYPE_ERROR',
    element: element || "main",
    message: (res && res.body && res.body.error) || ""
  }
}

export const post = (params) => {
  return (dispatch, getState) => {
    const state = getState().roomGroup
    const postApi = new PostApi()
    return postApi.execute(routeUrlHelper.roomGroupBedTypesPath(state.room_group_id), params).then((res) => {
      const errorHelper = new ErrorHelper("", state.error)
      dispatch( setState({ bed_types: res.body, error: errorHelper.clearError(params) }))
    },
    (res) => {
      if (!res.body.hasOwnProperty('errors') && res.body.hasOwnProperty('error')) {
        res.body = Object.assign(res.body, { errors: { bed_types: [res.body.error] } } )
      }

      const errorHelper = new ErrorHelper(res, state.error)
      dispatch( setState({ error: errorHelper.setError() }) )
    })
  }
}
